module.exports = __webpack_public_path__ + "static/html-element_2-f44d14bf7207478611f2143e69c89998.jpg";